/**
 * @fileoverview Shared NoteVisit schema used by both frontend and backend.
 * Immutable event log tracking note access and visits by users.
 */

import { z } from 'zod';
import { commonValidators, createCrudSchemas, createEntityIdSchema, createdAtSchema, getSchemaFields } from './base.js';
import { ID_PATTERNS } from './types.js';

/**
 * NoteVisit validation schema (immutable event log).
 * NoteVisit rows are immutable and do not have updated_at or deleted_at.
 */
export const NoteVisitSchema = z.object({
  id: createEntityIdSchema(ID_PATTERNS.NOTE_VISIT, 'ID must be in note_visit nanoid7 format (nv + digit 2-9 + 4 alphanumeric)'),
  note_id: commonValidators.noteForeignKey('Note ID'),
  account_id: commonValidators.foreignKey('Account ID'),
  visited_at: z.string()
    .transform((val): string | undefined => (val === '' ? undefined : val))
    .pipe(
      z.string()
        .datetime('Visited at must be a valid ISO datetime')
    )
    .optional(),
  metadata: commonValidators.jsonField('Metadata'),
  created_at: createdAtSchema,
});

const { CreateSchema } = createCrudSchemas(NoteVisitSchema, { omitDeletedAt: false });

export const NoteVisitCreateSchema = CreateSchema;

export type NoteVisit = z.infer<typeof NoteVisitSchema>;
export type NoteVisitCreate = z.infer<typeof NoteVisitCreateSchema>;

export const NOTE_VISIT_FIELDS = getSchemaFields(NoteVisitSchema);
